import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { GenericCrudEditComponent } from 'src/app/libs/components/generic-crud/generic-crud-edit.component';
import { ConsignmentStock, Organization, EMasterState } from 'src/app/models';
import { OrganizationsAddComponent } from 'src/app/routes/directory/directory-stakeholders/organizations/organizations-add/organizations-add.component';
import { OrganizationsEditComponent } from 'src/app/routes/directory/directory-stakeholders/organizations/organizations-edit/organizations-edit.component';

@Component({
    selector: 'app-products-consignment-stocks-edit',
    templateUrl: './products-consignment-stocks-edit.component.html',
    styleUrls: ['./products-consignment-stocks-edit.component.css'],
    standalone: false
})
export class ProductsConsignmentStocksEditComponent extends GenericCrudEditComponent<ConsignmentStock>{

  @Input() organizations?: Organization[];
  createOrganizationComponent = OrganizationsAddComponent;
  editOrganizationComponent = OrganizationsEditComponent;
  override resource = this.api.resources.product.consignmentStocks;
  displayEntity = () => this.entity!.reference + ' ' + this.entity!.description;
    
  protected override async preFetch(): Promise<void> {
    if (!this.organizations) {
      this.organizations = await firstValueFrom(this.api.resources.organization.organizations.getAll({ companyId: this.api.auth.userValue?.lastCompanyId, stateId: EMasterState.Active }));
    }
  }

  initFormGroup(): FormGroup {
    return this.fb.group({
      id: [this.entity!.id],
      reference: [this.entity!.reference],
      description: [this.entity!.description],
      date: [this.entity!.date],
      organizationId: [this.entity!.organizationId],
    });
  }
}
